import { render, staticRenderFns } from "./ComplaintDetailsPage.vue?vue&type=template&id=280dddff&scoped=true"
import script from "./ComplaintDetailsPage.vue?vue&type=script&lang=js"
export * from "./ComplaintDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./ComplaintDetailsPage.vue?vue&type=style&index=0&id=280dddff&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280dddff",
  null
  
)

export default component.exports